import {NodeBushEntry} from "../useVisionBoardData";
import {VisionBoardBag} from "../canvas-utils";
import {useNodeData} from "../canvas-node-utils";
import TextWidget from "./TextWidget";
import ImageWidget from "./ImageWidget";
import CardWidget from "./CardWidget";
import FilterWidget from "./FilterWidget";
import {ErrorBoundary} from "../../../lib/ErrorBoundary";
import {Col, Text} from "@cdx/ds";

const ErrorContainer = ({node}: {node: NodeBushEntry}) => {
  const style = {
    top: node.minY,
    left: node.minX,
    width: node.maxX - node.minX,
    height: node.maxY - node.minY,
  };
  return (
    <Col
      absolute
      style={style}
      colorTheme="alert800"
      justify="center"
      align="center"
      bg="foreground"
      rounded={4}
      border="1px"
    >
      <Text type="label12" color="primary">
        This Widget crashed 😢
      </Text>
    </Col>
  );
};

type CanvasNodeProps = {
  node: NodeBushEntry;
  bag: VisionBoardBag;
};
const CanvasNode = ({node: bushNode, bag}: CanvasNodeProps) => {
  const {node: nodeMap} = bushNode;
  const node = useNodeData(nodeMap);

  const getContent = () => {
    switch (node.type) {
      case "text":
        return <TextWidget node={bushNode} nodeData={node} bag={bag} />;
      case "image":
        return <ImageWidget node={bushNode} nodeData={node} bag={bag} />;
      case "card":
        return <CardWidget node={bushNode} nodeData={node} bag={bag} />;
      case "filter":
        return <FilterWidget node={bushNode} nodeData={node} bag={bag} />;
      default:
        if (process.env.NODE_ENV !== "production") {
          console.warn(`Unknown node: '${(node as any).type}'`);
        }
        return null;
    }
  };
  return (
    <ErrorBoundary fallback={<ErrorContainer node={bushNode} />}>{getContent()}</ErrorBoundary>
  );
};

export default CanvasNode;
